import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";

const ProposalInfoLink = styled(Link)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.info.main,
  cursor: "pointer",
  textDecorationColor: theme.palette.info.main,
  "&:hover": {
    color: theme.palette.info.dark,
    textDecorationColor: theme.palette.info.dark,
  },
}));

export default ProposalInfoLink;
